import { ICarrierOutputDto } from './carrier-output-dto.interface';
import { IDriverDeviceOutputDto } from './driver-device-output-dto.interface';
import { IDriverTachographOutputDto } from './driver-tachograph-output-dto.interface';
import { ITagOutputDto } from './tags-output-dto.interface';
import { ExternalDriverAllowedActions } from '../enums';

export interface IDriverOutputDto {
    id: string;
    organizationId?: string;
    externalId?: string | null;
    name: string;
    surname: string;
    fullName?: string;
    inDuty?: boolean;
    nationalId: string;
    carrier: string | ICarrierOutputDto;
    code?: string;
    licenseNumber?: string;
    phoneNumber: string;
    status?: string;
    assignedVehicle?: string;
    photo?: string;
    tags?: string[] | ITagOutputDto[];
    invitationLink?: string;
    wasInvited?: boolean;
    blocked?: boolean;
    tachograph?: IDriverTachographOutputDto;
    device?: IDriverDeviceOutputDto;
    createdAt?: string;
    updatedAt?: string;
    externalOrganizations?: IDriverExternalOrganizationsOutputDto[];
}

export interface IDriverExternalOrganizationsOutputDto {
    organizationId: string;
    allowedActions?: ExternalDriverAllowedActions[];
}
